// @flow
/* eslint-disable react/no-unknown-property */
import type { SeoLinksType } from 'components/PageContext';

export default function getLinkTags(links: SeoLinksType) {
  const linkTags = [];
  if (links) {
    linkTags.push(
      <link
        key="canonical"
        rel="canonical"
        href={`${CONFIG.publicUrl}${links.canonical}`}
      />
    );
    links.alternates.forEach(({ lang, href }) => {
      linkTags.push(
        <link
          rel="alternate"
          hreflang={lang}
          href={`${CONFIG.publicUrl}${href}`}
          key={href}
        />
      );
    });
    if (links.next) {
      linkTags.push(
        <link rel="next" href={`${CONFIG.publicUrl}${links.next}`} key="next" />
      );
    }
    if (links.prev) {
      linkTags.push(
        <link rel="prev" href={`${CONFIG.publicUrl}${links.prev}`} key="prev" />
      );
    }
  }
  return linkTags;
}
